
import { defineComponent } from "@vue/runtime-core";
import MainScreen from "./views/MainScreen.vue";
import treeData from "./tree.json";

export default defineComponent({
  name: "App",
  components: { MainScreen },
  computed: {},
  methods: {},
  data() {
    return {
      treeData: treeData,
    };
  },
});
